import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_SUGGESTIONS_INDEX
} from 'constants/general'

const hasAlgoliaConfig = Boolean(
    ALGOLIA_APP_ID && ALGOLIA_SEARCH_KEY && ALGOLIA_SUGGESTIONS_INDEX
)

export default async function getSearch({ typeSearch = '' } = {}) {
    const query = String(typeSearch).trim()

    if (query.length < 3 || !hasAlgoliaConfig) {
        return { cadena: query, suggestions: [] }
    }

    try {
        const response = await fetch(
            `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/${encodeURIComponent(ALGOLIA_SUGGESTIONS_INDEX)}/query`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Algolia-Application-Id': ALGOLIA_APP_ID,
                    'X-Algolia-API-Key': ALGOLIA_SEARCH_KEY
                },
                body: JSON.stringify({ query, hitsPerPage: 8 })
            }
        )

        if (!response.ok) {
            throw new Error(`Algolia response ${response.status}`)
        }

        const data = await response.json()
        const suggestions = (data.hits || [])
            .map(hit => hit.query || hit.title || hit.name || '')
            .filter(Boolean)
            .map(nombre => ({ clase: 'word_item', nombre }))
        return { cadena: query, suggestions }
    } catch (error) {
        console.error('No fue posible obtener sugerencias de Algolia', error)
        return { cadena: query, suggestions: [] }
    }
}
